import * as THREE from 'three';

declare module 'three' {
  interface Ray {
    distanceToPlaneWithNegative(plane: THREE.Plane): number | null;
  }
}

THREE.Ray.prototype.distanceToPlaneWithNegative = function (
  this: THREE.Ray,
  plane: THREE.Plane,
): number | null {
  const denominator = plane.normal.dot(this.direction);
  if (denominator === 0) {
    if (plane.distanceToPoint(this.origin) === 0) {
      return 0;
    }
    return null;
  }
  const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
  return t;
};
